import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M440-240v-368L296-464l-56-56 240-240 240 240-56 56-144-144v368h-80Z" }));
export default SvgArrowUp;
